import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton, SIZE, ROLE } from 'baseui/modal';
import { KIND as ButtonKind } from 'baseui/button';

interface IConfirmationModalProps {
	confirmationHeader?: string;
	confirmationMessage?: string;
	agreeLabel?: string;
	closeLabel?: string;
	onClose: any;
	confirmationDialogOnAgree: any;
}

const ConfirmationModal: React.FC<IConfirmationModalProps> = (props) => {
	const {
		confirmationHeader,
		confirmationMessage,
		agreeLabel = 'Yes',
		closeLabel = 'No',
		onClose,
		confirmationDialogOnAgree
	} = props;
	return (
		<Modal onClose={onClose} closeable isOpen animate autoFocus size={SIZE.default} role={ROLE.dialog}>
			<ModalHeader>{confirmationHeader || 'Confirmation'}</ModalHeader>
			{confirmationMessage && <ModalBody>{confirmationMessage}</ModalBody>}
			<ModalFooter>
				<ModalButton onClick={onClose} kind={ButtonKind.tertiary}>
					{closeLabel}
				</ModalButton>
				<ModalButton onClick={confirmationDialogOnAgree}>{agreeLabel}</ModalButton>
			</ModalFooter>
		</Modal>
	);
};

export default ConfirmationModal;
